import React from "react";
import "../CSS/patform.css";
import Logo from "../../Assets/logo.png";
import Google from "../../Assets/googl_1.png";
import Facebook from "../../Assets/face_1.png";
import Trip from "../../Assets/trip_1.png";
import User from "../../Assets/dummyM.png";
import Back from "../../Assets/neww.webp";
import Error from "../../Assets/erorNew.png";
function PlatformScreen() {
  return (
    <>
      <div className="screen_contianer" style={{ backgroundImage: Back }}>
        <div className="screen_wrapper">
          <div>
            <div className="logo_wrapper">
              <img src={Logo} alt="Logo" />
            </div>
            <div className="heading_1">
              <h4>“Your Feedback Matters!”</h4>
            </div>
          </div>
          <div>
            <div className="heading_2">
              <p>
                Enjoyed your experience? Share your review on your favorite
                platform below!
              </p>
            </div>
            <div className="platform_buttons">
              <button>
                <img src={Google} alt="Wowreviews" />
              </button>
              <button>
                <img src={Facebook} alt="Wowreviews" />
              </button>
              <button>
                <img src={Trip} alt="Wowreviews" />
              </button>
            </div>
          </div>
          <div style={{ width: "100%" }}>
            <div className="heading_2">
              <p>"If you had a bad experience!"</p>
            </div>
            <div className="contact_btn">
              <button>
                <img src={User} alt="Wowreviews" />
                <p>Contact Manager</p>
              </button>
            </div>
          </div>
        </div>

        <div className="screen_wrapper screen_wrapperForm dnone">
          <div style={{ width: "100%" }}>
            <h6>Submit Your Feedback</h6>
            <form style={{ width: "100%" }}>
              <div className="input_container">
                <label htmlFor="name">YOUR NAME:</label>
                <br />
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Please enter first name"
                  required=""
                />
              </div>
              <div className="input_container">
                <label htmlFor="email">PHONE NO:</label>
                <br />
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Please enter phone No."
                  required=""
                />
              </div>
              <div className="input_container">
                <label htmlFor="email">EMAIL ID:</label>
                <br />
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Please enter email id"
                  required=""
                />
              </div>
              <div className="input_container">
                <label htmlFor="message">REVIEW:</label>
                <br />
                <textarea
                  id="message"
                  name="message"
                  placeholder="Please enter feedback"
                  required=""
                  defaultValue={""}
                />
              </div>
              <div style={{ width: "100%" }}>
                <div className="contact_btn">
                  <button>
                    <p>Submit</p>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* Error Screen */}
        <div className="screen_wrapper dnone">
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img className="errorImg" src={Error} alt="Wowreviews" />
          </div>
          <div style={{ width: "100%" }}>
            <div className="heading_1" style={{ marginBottom: "2rem" }}>
              <h2>Opps!</h2>
            </div>
            <div
              className="heading_2"
              style={{ lineHeight: "30px", marginBottom: "1.5rem" }}
            >
              <p>
                Something went wrong, please notify
                <br />
                the owner about this issue!!!
              </p>
            </div>
            <div className="contact_btn">
              <button>
                <p>Notify the Owner</p>
              </button>
            </div>
          </div>
        </div>
        {/* Error Screen */}
      </div>
    </>
  );
}

export default PlatformScreen;
